import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-explore',
	templateUrl: './icon-explore.component.svg',
})
export class IconExploreComponent {}
